(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/qr-scanner/assets/javascripts/components/focus-box.js') >= 0) return;  svs.modules.push('/components/tur/qr-scanner/assets/javascripts/components/focus-box.js');
"use strict";


setGlobal('svs.tur.qrScanner.components.FocusBox', () => React.createElement("div", {
  className: "qr-focus-box-container"
}, React.createElement("div", {
  className: "qr-focus-box"
}, React.createElement("div", {
  className: "corner top-left"
}), React.createElement("div", {
  className: "corner top-right"
}), React.createElement("div", {
  className: "corner bottom-left"
}), React.createElement("div", {
  className: "corner bottom-right"
}))));

 })(window);